import { render, staticRenderFns } from "./RsncQuestionComponent.vue?vue&type=template&id=c313e582&scoped=true&"
import script from "./RsncQuestionComponent.vue?vue&type=script&lang=js&"
export * from "./RsncQuestionComponent.vue?vue&type=script&lang=js&"
import style0 from "./RsncQuestionComponent.vue?vue&type=style&index=0&id=c313e582&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c313e582",
  null
  
)

export default component.exports